import { Inject, Injectable } from '@angular/core';
import type { BearerToken, IrisStatusResponse } from './iris.interface';
import { angularjs } from '../migration-helpers/angularjs.injection';
import type angular from 'angular';

@Injectable({ providedIn: 'root' })
export class IrisClient {
  $http: angular.IHttpService;

  constructor(@Inject(angularjs.$http) $http: angular.IHttpService) {
    this.$http = $http;
  }

  getAuthToken(): angular.IHttpPromise<{ bearerTokenURL: string }> {
    return this.$http.post('image/imageAuthorization', null);
  }

  getBearerToken(url: string): angular.IHttpPromise<BearerToken> {
    return this.$http.get<BearerToken>(url);
  }

  getStatus(url: string, bearerToken: string): angular.IHttpPromise<IrisStatusResponse> {
    return this.$http.get(`${url}/signed-url`, {
      headers: { Authorization: `Bearer ${bearerToken}` }
    });
  }
}
